module.exports = __webpack_public_path__ + "img/3_49.0fb32384.png";